var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4952 12.9792L19.4389 13.3101C19.5844 12.8952 19.4418 12.434 19.0876 12.1736C18.7335 11.9131 18.2507 11.9145 17.8981 12.177L18.4952 12.9792ZM10.5132 1.01439L11.026 1.8729C11.4032 1.64755 11.5892 1.20231 11.4842 0.775575C11.3793 0.34884 11.0081 0.0406257 10.5693 0.0159618L10.5132 1.01439ZM17.8981 12.177C16.8657 12.9456 15.5874 13.4001 14.2 13.4001V15.4001C16.0322 15.4001 17.7266 14.798 19.0924 13.7813L17.8981 12.177ZM14.2 13.4001C10.7758 13.4001 8 10.6243 8 7.20012H6C6 11.7289 9.67126 15.4001 14.2 15.4001V13.4001ZM8 7.20012C8 4.93744 9.21148 2.9567 11.026 1.8729L10.0004 0.155873C7.60665 1.58567 6 4.20476 6 7.20012H8ZM10 2C10.1535 2 10.3059 2.00431 10.4571 2.01281L10.5693 0.0159618C10.3808 0.00536424 10.191 0 10 0V2ZM2 10C2 5.58172 5.58172 2 10 2V0C4.47715 0 0 4.47715 0 10H2ZM10 18C5.58172 18 2 14.4183 2 10H0C0 15.5228 4.47715 20 10 20V18ZM17.5515 12.6483C16.4581 15.7664 13.4886 18 10 18V20C14.3643 20 18.0731 17.2048 19.4389 13.3101L17.5515 12.6483Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.51ab6dcaca2675f15770fd44e67f7135.svg";
export { ForwardRef as ReactComponent };